// オセアニア・太平洋の世界史スポット。
// 先住民社会の長い歴史、ポリネシアの拡散、そしてイギリスの植民地化を代表させる。

export const OCEANIA_SITES = [
  {
    id: 'uluru',
    name: 'ウルル',
    nameEn: 'Uluru',
    lat: -25.3444, lng: 131.0369, elevationM: 860,
    region: 'oceania', era: 'prehistory',
    country: 'オーストラリア（ノーザンテリトリー）',
    civilization: 'アボリジニ（アナング）',
    yearLabel: '数万年にわたる先住民の聖地',
    whcYear: 1987,
    whcNote: '「ウルル、カタ・ジュタ国立公園」',
    emoji: '⛰',
    facts: [
      { label: '規模', value: '周囲 約9.4km・比高 約340m' },
    ],
    summary:
      'オーストラリア中央部の平原に孤立してそびえる巨大な砂岩の岩体。先住民アボリジニのアナングの人々にとって、祖先の営みを語る「ドリーミング」に結びついた聖地であり、周囲の岩陰には古い壁画が残る。アボリジニは5万年以上前に大陸へ渡り、文字を持たないまま歌と物語と絵によって土地の記憶を伝えてきた。1788年のイギリスによる植民以降、土地と文化は激しく損なわれたが、1985年にウルルの所有権はアナングへ返還され、2019年からは登山も禁止されている。',
    quiz: {
      statement: 'ウルルは観光名所として、現在も誰でも自由に登ることができる。',
      answer: false,
      explain: '1985年に所有権が先住民アナングへ返還され、聖地への敬意から2019年10月に登山は全面的に禁止されました。',
    },
  },
  {
    id: 'rapa-nui',
    name: 'ラパ・ヌイ（アフ・トンガリキ）',
    nameEn: 'Rapa Nui, Ahu Tongariki',
    lat: -27.1256, lng: -109.2769, elevationM: 20,
    region: 'oceania', era: 'medieval',
    country: 'チリ（イースター島）',
    civilization: 'ポリネシア',
    yearLabel: '13〜16世紀頃にモアイを造営',
    whcYear: 1995,
    emoji: '🗿',
    summary:
      '南太平洋の絶海の孤島に、13世紀頃から数百体のモアイ像が立てられた。ポリネシア人はカヌーと星や海流の知識だけで太平洋の島々へ広がり、この島にも到達している。像は祖先を表し、集落を見守るように内陸を向いて立つ。かつては森林破壊による自給自足社会の崩壊という説が広く語られたが、近年はネズミによる種子の食害や、ヨーロッパ人の接触後にもたらされた感染症と奴隷狩りの影響を重く見る研究が進み、見直しが続いている。',
    quiz: {
      statement: 'ラパ・ヌイ（イースター島）に人が住み着いたのは、ポリネシア人が太平洋へ拡散した結果である。',
      answer: true,
      explain: 'ポリネシア人はカヌーと天文・海流の知識で太平洋各地へ広がりました。ラパ・ヌイはその東端に近く、ハワイ・ニュージーランドと三角形をなします。',
    },
  },
  {
    id: 'hyde-park-barracks',
    name: 'ハイド・パーク・バラックス（シドニー）',
    nameEn: 'Hyde Park Barracks',
    lat: -33.8690, lng: 151.2124, elevationM: 30,
    region: 'oceania', era: 'modern',
    country: 'オーストラリア（ニューサウスウェールズ州）',
    civilization: 'イギリス流刑植民地',
    yearLabel: '1819年 完成',
    whcYear: 2010,
    whcNote: '「オーストラリアの囚人遺跡群」の一部',
    emoji: '⛓',
    summary:
      'イギリスは1788年からオーストラリアへ囚人の流刑を始め、80年間で約16万人を送り込んだ。1819年に建てられたこの宿舎は、男性囚人を収容した施設である。アメリカ独立で流刑先を失ったこと、そして本国の急激な人口増加と貧困が、この政策の背景にあった。囚人たちは道路や建物の建設に従事し、刑期を終えると入植者となって植民地社会を形づくった。一方で、先住民アボリジニは土地を奪われ人口を激減させており、この地の近代史は二つの側面を併せ持っている。',
    quiz: {
      statement: 'イギリスがオーストラリアへの囚人流刑を始めた背景には、アメリカの独立で従来の流刑先を失ったことがある。',
      answer: true,
      explain: 'それまで囚人は北アメリカへ送られていましたが、1776年の独立でその道が絶たれました。1788年に最初の船団がシドニー湾へ到着します。',
    },
  },
  {
    id: 'waitangi',
    name: 'ワイタンギ条約締結地',
    nameEn: 'Waitangi Treaty Grounds',
    lat: -35.2650, lng: 174.0820, elevationM: 20,
    region: 'oceania', era: 'modern',
    country: 'ニュージーランド（ノースランド）',
    civilization: 'マオリ／イギリス植民地',
    yearLabel: '1840年2月6日 調印',
    whcYear: null,
    emoji: '📜',
    summary:
      '1840年、イギリス王室と先住民マオリの首長たちが条約を結んだ場所。マオリはポリネシア人の一派で、13世紀頃にこの島々へ渡り、部族社会を築いていた。条約は英語版とマオリ語版で内容にずれがあり、英語版が「主権の譲渡」を記すのに対し、マオリ語版は統治権の委任にとどまると読める。この差異が土地の収奪をめぐる長い争いを生んだ。1975年にワイタンギ審判所が設けられ、条約違反の申し立てを審理し補償を進める仕組みができている。',
    quiz: {
      statement: 'ワイタンギ条約は英語版とマオリ語版で内容に食い違いがあり、後の紛争の原因となった。',
      answer: true,
      explain: '英語版は主権の譲渡と読めるのに対し、マオリ語版は統治権の委任と読めます。この違いが土地問題をめぐる長い係争を生みました。',
    },
  },
  {
    // 出典: https://whc.unesco.org/en/list/1131/
    sources: ['https://whc.unesco.org/en/list/1131/'],
    id: 'royal-exhibition-building',
    name: '王立展示館（メルボルン）', nameEn: 'Royal Exhibition Building',
    lat: -37.8047, lng: 144.9717, elevationM: 35,
    region: 'oceania', era: 'modern',
    country: 'オーストラリア（メルボルン）', civilization: '19世紀の国際博覧会',
    yearLabel: '1880年 メルボルン国際博覧会のため建設',
    whcYear: 2004, whcNote: '「王立展示館とカールトン庭園」', emoji: '🏛',
    summary:
      '1880年のメルボルン国際博覧会のために建てられ、1888年の博覧会にも使われた展示施設。大きなドームを中心とする建物と、その前後に広がるカールトン庭園が一体に設計されている。19世紀の博覧会では、各国の工業製品や新技術が集められ、人々は遠い地域の成果に触れた。展示は学びと交流の機会である一方、開催する国や植民地の繁栄を世界に示す手段でもあった。王立展示館は、こうした国際博覧会の文化を建物と庭園の両方から伝える。空から左右に広がる展示空間と並木道を眺めれば、多くの人を迎える会場の構成が分かる。パリのエッフェル塔と結び付けると、遠く離れた都市が博覧会という共通の仕組みで技術や情報を交換した歴史をたどれる。',
    quiz: {
      statement: 'メルボルンの王立展示館は、中世の王が暮らす城として建てられた。',
      answer: false,
      explain: '1880年の国際博覧会のためにつくられた展示館です。「王立」という名前だけで、中世の城や宮殿とは判断できません。',
    },
  },
];
